export enum ProviderType {
  Tax,
  Insurance,
  Garnishment,
  Others,
}
